import React from 'react';
import { FormattedMessage } from 'react-intl';

import { assertUnreachable } from 'utils/assertUnreachable';

import type { SSOLoginMethod } from '../LoginSelection';

export const Message: React.VFC<{
  method: SSOLoginMethod;
}> = ({ method }) => {
  switch (method) {
    case 'Amazon':
      return (
        <FormattedMessage
          defaultMessage="Continue with Amazon"
          description="Button that uses Amazon sign in"
        />
      );
    case 'Apple':
      return (
        <FormattedMessage
          defaultMessage="Continue with Apple"
          description="Button that uses Apple sign in"
        />
      );
    case 'Google':
      return (
        <FormattedMessage
          defaultMessage="Continue with Google"
          description="Button that uses Google sign in"
        />
      );
    case 'Indeed':
      return (
        <FormattedMessage
          defaultMessage="Continue with Indeed"
          description="Button that uses Indeed sign in"
        />
      );
    default:
      return assertUnreachable(method);
  }
};
